import React, { useState } from "react";
import { Navbar } from "../../components/navbar";
import './style.scss';
import closed from "../../assets/icons/incorrect.png"
import { AdDialogBox } from "../../components/adPageDialog/index"

export const AdPage: React.FC = () => {
    const [file, setFile] = useState<any>()
    const [show, setShow] = useState<boolean>(false)
    const handleSend = () => {
        setShow(true)
    }
    return (
        <div className="adPage">
            <Navbar noAds={true} />
            <div className="heading">
                <h1>ADD ADVERTISEMENT</h1>
            </div>
            <div className="containers">
                <div className="container1">
                    <div className="text">
                        <p className="title">
                            Upload The Advertisement File
                        </p>
                        <p className="red">(Please Upload a File whose Dimension 728*90)</p>
                        <p className="red">(File Type: Image Format)</p>
                        <p className="red">(File size 35KB)</p>
                    </div>
                    <div className="files">
                        {file ? <></> : <div className="bulk-upload">
                            <label className="custom-file-upload">
                                <input
                                    type="file"
                                    multiple={false}
                                    onChange={(e) => {
                                        setFile(e.target.files)
                                    }}
                                />
                                <div className="upload-btn">
                                    <span className="txt"> Upload</span>
                                </div>
                            </label>
                        </div>}
                        {file &&
                            <div className="filename">
                                <img src={closed} alt="ad content" className="icon" onClick={() => setFile(null)} />
                                <p>
                                    {file[0].name}
                                </p>
                            </div>
                        }
                    </div>
                </div>
                <div className="container2">
                    <div className="text">
                        <p className="title">
                            Specify The Url to Which The User Has To
                        </p>
                        <p className="title">
                            Navigate On Clicking The Ad
                        </p>
                    </div>
                    <div className="link">
                        <input type="Link" id="link" pattern="https://.*" />
                    </div>
                </div>
            </div>
            <div className="submit-btn">
                <button className="btn" onClick={handleSend}  >Upload</button>
            </div>
            {show && <AdDialogBox show={show} setShow={setShow} />}
        </div>
    )
}
